/**
 * QualidadePage (M10, RF-M10-003, PC-04) — painel de qualidade: donut de
 * percentuais por marcador (somam 100%) + ranking de campos mais corrigidos.
 * Acesso universal de leitura. Sem PII (RN-GLOBAL-004).
 * ADR-038: o filtro Evidência separa as visitas da planilha (começam em alerta pelo ICCID perdido).
 */

import { MarcadorDonut } from '../components/MarcadorDonut';
import { RankingCamposTable } from '../components/RankingCamposTable';
import { useState } from 'react';
import { useQualidade } from '../hooks/usePainel';
import { FiltroEvidencia } from '../components/Evidencia';
import { Evidencia } from '../services/consulta-types';

export function QualidadePage(): JSX.Element {
  const [evidencia, setEvidencia] = useState<Evidencia | undefined>(undefined);
  const { qualidade, carregando, erro } = useQualidade(evidencia);
  const indisponivel = erro;

  return (
    <div>
      <h1 className="page-title">Qualidade</h1>
      <p className="page-subtitle">
        Distribuição das visitas por marcador e os campos mais corrigidos pela revisão humana.
      </p>

      <div className="filtros">
        <FiltroEvidencia id="qualidade-evidencia" semReferencias valor={{ evidencia }} onMudar={(v) => setEvidencia(v.evidencia)} />
      </div>

      {carregando && <p className="muted">Carregando…</p>}

      {indisponivel ? (
        <p className="notice">Os indicadores de qualidade estão temporariamente indisponíveis.</p>
      ) : (
        qualidade && (
          <>
            <section className="card">
              <h2>Distribuição por marcador</h2>
              <MarcadorDonut porMarcador={qualidade.porMarcador} />
            </section>

            <section className="card">
              <h2>Campos mais corrigidos</h2>
              <RankingCamposTable campos={qualidade.camposMaisCorrigidos} />
            </section>
          </>
        )
      )}
    </div>
  );
}
